import { createParser, system } from "../core";
import { t } from "../utils";
var config = {
  color: t.colors("color"),
  textColor: t.colors("color"),
  opacity: true,
  fill: t.colors("fill"),
  stroke: t.colors("stroke")
};
export var color = system(config);
export var colorParser = createParser(config);